import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import {
  MoneyDto,
  PriceScope,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export type Props = {
  bomItemId: string
  materialCostPrice: MoneyDto
  priceScope: PriceScope
}

export const saveBomItemMaterialCostPrice = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'boM/saveMaterialCostPrice',
  async ({ bomItemId, materialCostPrice, priceScope }: Props, thunkAPI) => {
    const { partyId: organizationId, projectId } = getContext(thunkAPI.getState)

    const controller = new BomItemController(organizationId, projectId)

    thunkAPI.dispatch(newProjectActions.resetBomItemFinancials([bomItemId]))

    try {
      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: bomItemId,
          financial: {
            salesPricePerItem: materialCostPrice,
          },
        } as Partial<PartTypeRow>)
      )
      await controller.SetMaterialCostPrice(
        bomItemId,
        materialCostPrice,
        priceScope
      )
    } catch (err) {
      ShowException('project', err)
      await thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
